module.exports = __webpack_public_path__ + "42e2f0a6d641ee091a325cd3ce12cd80.pdf";